import { AxiosError } from 'axios';
import { inject, injectable } from 'inversify';
import CreditCardsRepository from 'src/features/creditCards/data/CreditCardsRepository';
import { getMercadoPagoCardErrorMessage } from 'src/utils/cards/getMercadoPagoErrorMessage';
import { UnknownError } from 'src/utils/errors/UnknownError';

export interface SaveMercadoPagoCardParams {
  userId: number;
  accessToken: string;
  token: string;
}

@injectable()
class SaveMercadoPagoCardUseCase {
  @inject(CreditCardsRepository)
  private readonly creditCardsRepository!: CreditCardsRepository;

  public async execute(params: SaveMercadoPagoCardParams) {
    try {
      return await this.creditCardsRepository.saveCreditCard({
        ...params,
        payment_method: 'mercado-pago',
      });
    } catch (error) {
      if (
        error instanceof AxiosError &&
        error.response &&
        error.response.data?.code
      ) {
        const mercadoPagoErrorCode = error.response.data.code;
        const errorMsg = getMercadoPagoCardErrorMessage(mercadoPagoErrorCode);

        throw new Error(errorMsg);
      }

      throw new UnknownError(error);
    }
  }
}

export default SaveMercadoPagoCardUseCase;
